var _path, _circle, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeaIconThree(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 169,
    viewBox: "0 0 164 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.68 150H150.462M139.421 60.52L148.657 67.4749C149.98 68.4716 151.861 68.2066 152.858 66.8831C153.855 65.5595 153.59 63.6786 152.266 62.6819L139.399 52.9926L138.208 52.0957L76.4682 5.60349L74.612 4.20574L72.7945 5.65337L13.5343 52.8528L12.4033 53.7536L1.13096 62.7318C-0.165051 63.764 -0.378876 65.6515 0.653367 66.9475C1.68561 68.2435 3.57303 68.4573 4.86904 67.4251L12.4033 61.4242V147H3C1.34315 147 0 148.343 0 150C0 151.657 1.34315 153 3 153H12.4033H15.4033H136.68H139.689L139.421 60.52Z",
    fill: "#F9A749",
    stroke: "#191B45",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 127.556,
    cy: 132.556,
    r: 35.5556,
    fill: "#191B45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116 131.42L124.889 139.815L139.704 125",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6667 56V79.625M56.6667 119V79.625M56.6667 79.625H66C68.2091 79.625 70 77.8341 70 75.625V56M56.6667 79.625H46C43.7909 79.625 42 77.8341 42 75.625V56M86 119V98.75M86 98.75V56.4752C86 56.2981 86.208 56.2056 86.333 56.331C88.2994 58.3037 98.4294 68.7166 102 77.375C104.458 83.3354 105.488 92.5386 105.842 96.6458C105.941 97.7901 105.033 98.75 103.885 98.75H86Z",
    stroke: "#191B45",
    strokeWidth: 7,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaIconThree);
export default __webpack_public_path__ + "static/media/fea_icon_three.aeff526721114a8515e12cab7c50aed1.svg";
export { ForwardRef as ReactComponent };